import appTickettypes from "../../views/appCustomers/index.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("tickettypes", {
    url: "tickettypes?page&limit",
    parent: "app",
    views: {
      view: {
        template: appTickettypes,
      },
    },
    reloadOnSearch: false,
    data: { title: "Ticket Types" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/tickettypes/tickettypes.urls.js